import {CurrencyModel} from "./static-data.reducers";

export function handleBalanceChange(state: BalanceState, payload: any): void {
    if (payload) {
        state.balance = payload.balance;
    }
}

export function handleBindingChange(state: BalanceState, payload: any): void {
    if (payload) {
        state.bindings = payload.result ? payload.result : [];
    }
}

export interface BalanceState {
    balance: BalanceModel[],
    bonus: BonusModel[],
    bindings: BindingModel[]
}

export interface BalanceModel {
    balanceId: number,
    user: number,
    amount: number,
    currency: CurrencyModel,
    paymentId: string,
    paymentMethod: string
}

export interface BonusModel {
    balanceId: number,
    user: number,
    amount: number,
    currency: CurrencyModel
}

export interface BindingModel {
    CardHolderID: string,
    CardPan: string,
    ExpDate: string,
    IsActive: boolean
}
